export default __webpack_public_path__ + "static/media/PRA_bag_open 1.903be967.wav";